<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">INSTRUMENTS</li>
            </ol>
        </nav>
    </div>
    <div class="ms-auto">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" *ngIf="admin == 'true'" (click)="onAdd()">ADD INSTRUMENT</button>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center">
            <h5 class="mb-0"></h5>
            <form class="ms-auto position-relative">
                <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-search"></i></div>
                <input class="form-control ps-5" type="text" placeholder="search">
            </form>
        </div>
        <div class="table-responsive mt-3">
            <table class="table align-middle">
                <thead class="table-secondary">
                    <tr>
                        <th>NAME</th>
                        <th>DISPLAY NAME</th>
                        <th>SYMBOL</th>
                        <th>
                            <div>DERIVATIVE NAME</div>
                            <div>SPOT NAME</div>
                        </th>
                        <th>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let instrument of instruments">
                        <td>{{ instrument.name }}</td>
                        <td>{{ instrument.display_name }}</td>
                        <td>{{ instrument.symbol }}</td>
                        <td>
                            <div>{{ instrument.contract_details.derivative_name }}</div>
                            <div>{{ instrument.contract_details.spot_name }}</div>
                        </td>
                        <td>
                            <div class="table-actions d-flex align-items-center gap-3 fs-6">
                                <i class="bi bi-calendar-week text-primary" (click)="onViewAddInstrumentExpiry(instrument)"></i>
                                <i class="bi bi-pencil-fill pencil text-primary" (click)="onUpdate(instrument)"></i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<nav aria-label="Page navigation example" class="pagination" *ngIf="totalItems > 0">
    <ul class="pagination">
        <li class="page-item" (click)="prev()"><a class="page-link" href="javascript:;">Previous</a>
        </li>
        <li class="page-item" *ngIf="pageNumber < 10"><a class="page-link" href="javascript:;">{{pageNumber + 1}}</a>
        </li>
        <li class="page-item" (click)="next()"><a class="page-link" href="javascript:;">Next</a>
        </li>
    </ul>
</nav>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="instrumentExpiryModal" tabindex="-1" role="dialog" aria-labelledby="instrumentExpiryModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ modal_instrument_expiry.header }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose('instrument')"></button>
            </div>
            <div class="form modal-body" [formGroup]="instrument_expiry_modal_form">
                <div class="row">
                    <div class="col-md-6">
                        <label class="form-label">Name</label>
                        <div class="form-group">
                            <input type="text" autocomplete="off" class="form-control" [class.is-invalid]="display_name.invalid && display_name.touched" required formControlName="display_name" />
                            <div *ngIf="display_name.errors && display_name.invalid && display_name.touched">
                                <small class="text-danger" *ngIf="display_name_errors['required']">Display Name is required</small>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row" style="margin-top: 2%;">
                    <div class="col-md-3">
                        <label class="form-label">Year</label>
                        <div class="form-group">
                            <input type="number" min="2024" max="2099" step="1" value="2024" autocomplete="off" class="form-control" formControlName="year" />
                            <div *ngIf="year.errors && year.invalid && year.touched">
                                <small class="text-danger" *ngIf="year_errors['required']">Year is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Month</label>
                        <div class="form-group">
                            <input type="number" min="1" max="12" step="1" value="1" autocomplete="off" class="form-control" formControlName="month" />
                            <div *ngIf="month.errors && month.invalid && month.touched">
                                <small class="text-danger" *ngIf="month_errors['required']">Month is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <label class="form-label">&nbsp;</label>
                        <div class="form-group">
                            <button class="btn btn-primary" data-dismiss="modal" (click)="onViewExpiry('view')">
                        VIEW
                      </button>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">&nbsp;</label>
                        <div class="form-group">
                            <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="deleteAllExpiryDate()">
                        DELETE
                      </button>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 2%;">
                    <div class="col-md-4">
                        <label class="form-label">Expiry Date</label>
                        <div class="form-group">
                            <input type="date" class="form-control" formControlName="expiry_date">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="form-label">Type</label>
                            <select name="contactMethod" id="contactMethod" class="form-control" (ngModel)="expiry_type" formControlName="expiry_type">
                               <option value="" disabled selected>Select</option>
                               <option value="W">W</option>
                               <option value="M">M</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">&nbsp;</label>
                        <div class="form-group">
                            <button class="btn btn-success" data-dismiss="modal" (click)="onViewExpiry('add')">
                        ADD
                      </button>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 2%;">
                    <div class="table-responsive mt-3">
                        <table class="table align-middle">
                            <thead class="table-secondary">
                                <tr>
                                    <th>DATE</th>
                                    <th>TYPE</th>
                                    <th>ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let expiry of instrumentsExpiry">
                                    <td>{{ expiry.date }}</td>
                                    <td>{{ expiry.expiry }}</td>
                                    <td>
                                        <div class="table-actions d-flex align-items-center gap-3 fs-6">
                                            <i class="bi bi-trash-fill text-primary" (click)="onDeleteExpiryDate(expiry)"></i>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="onModalClose('expiry')">
          CANCEL
        </button>

                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="instrumentSaveModal" tabindex="-1" role="dialog" aria-labelledby="instrumentSaveModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ modal_instrument.header }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose('instrument')"></button>
                </div>
                <div class="form modal-body" [formGroup]="instrument_modal_form">
                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">Name</label>
                            <div class="form-group">
                                <input type="text" class="form-control" [class.invalid]="name.invalid && name.touched" formControlName="name" />
                                <div *ngIf="name.errors && name.invalid && name.touched">
                                    <small class="text-danger" *ngIf="name_errors['required']">Name is required</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Display Name</label>
                            <div class="form-group">
                                <input type="text" autocomplete="off" class="form-control" [class.is-invalid]="display_name.invalid && display_name.touched" required formControlName="display_name" />
                                <div *ngIf="display_name.errors && display_name.invalid && display_name.touched">
                                    <small class="text-danger" *ngIf="display_name_errors['required']">Display Name is required</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 2%;">
                        <div class="col-md-6">
                            <label class="form-label">Symbol</label>
                            <div class="form-group">
                                <input type="text" autocomplete="off" class="form-control" [class.is-invalid]="symbol.invalid && symbol.touched" required formControlName="symbol" />
                                <div *ngIf="symbol.errors && symbol.invalid && symbol.touched">
                                    <small class="text-danger" *ngIf="symbol_errors['required']">Symbol is required</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 2%;" *ngIf="modal_instrument.mode == 'add'">
                        <div class="col-md-6">
                            <label class="form-label">Derivative Name</label>
                            <div class="form-group">
                                <input type="text" class="form-control" formControlName="derivative_name">
                                <div *ngIf="derivative_name.errors && derivative_name.invalid && derivative_name.touched">
                                    <small class="text-danger" *ngIf="derivative_name_errors['required']">Derivative Name is required</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Spot Name</label>
                            <div class="form-group">
                                <input type="text" class="form-control" formControlName="spot_name">
                                <div *ngIf="spot_name.errors && spot_name.invalid && spot_name.touched">
                                    <small class="text-danger" *ngIf="spot_name_errors['required']">Spot Name is required</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="onModalClose('instrument')">
          CANCEL
        </button>
                    <button class="btn btn-primary" (click)="saveInstrument()" [disabled]="instrument_modal_form.invalid">
          {{ modal_instrument.btn_text }}
        </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="confirmationInstrumentModal" tabindex="-1" role="dialog" aria-labelledby="confirmationInstrumentModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationInstrumentModalLabel">ALERT</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose('confirmation')"></button>
                </div>
                <div class="modal-body px-5">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="fs-15"> {{ cm_params.msg }}
              <b>{{ cm_params.tag }}</b></span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary btn-block" data-dismiss="modal" (click)="onModalClose('confirmation')">
          CANCEL
        </button>
                    <button class="btn btn-danger btn-block" [ngClass]="cm_params.btn_class" (click)="onConfirm()">
          {{ cm_params.btn_text }}
        </button>
                </div>
            </div>
        </div>
    </div>